import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { ScrollToTop, SmoothScroll } from "./components/site/SmoothScroll";
import { AuthProvider, RequireAdmin } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { CartButton } from "./components/cart/Cart";
import BookingList from "./pages/BookingList";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import OrderNotePage from "./pages/OrderNotePage";

const SiteLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
    <CartButton />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
      <SmoothScroll />
      <ScrollToTop />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/c/:slug" element={<Gallery />} />
          <Route path="/booking-list" element={<BookingList />} />
        </Route>
        <Route path="/admin" element={<AuthProvider />}>
          <Route index element={<RequireAdmin><Admin /></RequireAdmin>} />
          <Route path="login" element={<AdminLogin />} />
          <Route path="orders/:id" element={<RequireAdmin><OrderNotePage /></RequireAdmin>} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
